module.exports = __webpack_public_path__ + "static/img/Application-closes.5d121182.png";